import { bunja } from 'bunja';

import { KycClientStatusEnum } from '@flipster/apis/v1/kyc/types';
import { UserBlockServiceEnum, UserBlockServiceType } from '@flipster/apis/v1/user/types';
import { FormattedMessage } from '@flipster/i18n';
import { RouterScope } from '@flipster/react/providers/route';
import { alert } from '@flipster/ui/Alert';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import segment, { WalletEvent } from '@flipster/utils/segment';

import { kycBunja } from '../../../kyc';
import { userBlockBunja } from '../../../user-block/state';
import { zendesk } from '../../../zendesk/url';
import { WalletModalType } from '../core/state';

const UserBlockMapper: Record<'deposit' | 'convert' | 'withdraw', UserBlockServiceType> = {
  withdraw: UserBlockServiceEnum.Withdrawal,
  deposit: UserBlockServiceEnum.Deposit,
  convert: UserBlockServiceEnum.Conversion,
};

export const accountValidationBunja = bunja(() => {
  const router = bunja.use(RouterScope);
  const store = bunja.use(JotaiStoreScope);
  // To get fresh data by awaiting promiseAtom, you should not use data atom - it is not updated synchronously.
  const { promiseAtom: kycPromiseAtom } = bunja.use(kycBunja);
  const { promiseAtom: userBlockPromiseAtom } = bunja.use(userBlockBunja);
  async function fetchKycInfo() {
    const { promise } = store.get(kycPromiseAtom);
    return await promise; // catch here?
  }
  async function checkKycAndOpenAlertIfNeeded() {
    const kycInfo = await fetchKycInfo();
    const isAchieved =
      kycInfo!.currentKYCLevel >= kycInfo!.desirableKYCLevel && kycInfo?.clientStatus === KycClientStatusEnum.Active;
    if (!isAchieved) {
      alert.show({
        title: <FormattedMessage id='Assets.r250401.Identity_verification' />,
        message: <FormattedMessage id='Assets.r250401.Identity_verification_required_description' />,
        confirmText: <FormattedMessage id='Assets.r250401.Verify_now' />,
        closeText: <FormattedMessage id='Reward_hub.r250213.Close' />,
        onConfirm() {
          segment.track(WalletEvent.KycVerificationRequireClick, { kyc_level: kycInfo.currentKYCLevel });
          router.push('/user/kyc');
        },
        onClose() {
          segment.track(WalletEvent.VerifyCancelButton);
        },
        withClose: true,
      });
    }
    return isAchieved;
  }
  async function checkUserBlockAndOpenAlertIfNeeded(type: WalletModalType) {
    const { promise: userBlockPromise } = store.get(userBlockPromiseAtom);
    const userBlockList = await userBlockPromise; // catch here?
    const blockInfo = userBlockList?.[UserBlockMapper[type]];
    if (blockInfo) {
      alert.show({
        title: <FormattedMessage id='Assets.r250401.Account_suspended' />,
        message: <FormattedMessage id='Assets.r250401.Account_suspended_description' />,
        confirmText: <FormattedMessage id='Assets.r250401.Contact_support' />,
        closeText: <FormattedMessage id='Reward_hub.r250213.Close' />,
        onConfirm: () => {
          window.open(zendesk.getUrl('RequestNew'), '_blank', 'noopener');
        },
        withClose: true,
      });
      return false;
    }
    return true;
  }
  return { checkKycAndOpenAlertIfNeeded, checkUserBlockAndOpenAlertIfNeeded };
});
accountValidationBunja.debugLabel = 'accountValidationBunja';
